import { Navigate } from "react-router-dom";

const RoleGuard = ({
  roles,
  children,
}: {
  roles: string[];
  children: any;
}) => {
  let role = "";
  try {
    const stored = localStorage.getItem("user");
    role = stored ? JSON.parse(stored)?.role || "" : "";
  } catch (error) {
    role = "";
  }

  if (!roles.includes(role)) {
    return <Navigate to="/dashboard/app" replace />;
  }

  return children;
};

export default RoleGuard;
